import ClientComponent from '@/components/ClientComponent/ClientComponent';
import * as S from '@/components/UploadFile/components/FileThumbnail/FileThumbnail.styles';
import { Skeleton } from '@mantine/core';
import dynamic from 'next/dynamic';
import React, { FC, useEffect } from 'react';
import { PageProps } from 'react-pdf';

type PageType = React.FC<PageProps>;
const Document = dynamic(() => import('react-pdf').then((mod) => mod.Document), { ssr: false });
const Page = dynamic(() => import('react-pdf').then((mod) => mod.Page as PageType), { ssr: false }); // Forcing the type to avoid conflict with the dynamic

type PdfDocumentProps = {
  fileUrl: string;
};

const PdfThumbnailComponent: FC<PdfDocumentProps> = ({ fileUrl }) => {
  const [file, setFile] = React.useState<File | null>(null);

  // Effects
  useEffect(() => {
    if (typeof window === 'undefined') return; // skip for server-side
    (async () => {
      const { pdfjs } = await import('react-pdf');
      pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    })();

    // Get File from fileUrl (string)
    const getFile = async () => {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const file = new File([blob], fileUrl.split('/').pop() || 'file.pdf', { type: blob.type });
      setFile(file);
    };

    getFile();
  }, []);

  const canvasRef = React.useRef<HTMLCanvasElement>(null);

  return (
    <S.Wrapper width="100%" height="300px" ratio="9/16">
      <React.Suspense fallback={<Skeleton width="100%" height={300} radius={10} />}>
        <Document loading={<Skeleton width="100%" height={300} radius={10} />} file={file}>
          <Page
            canvasRef={canvasRef}
            pageIndex={1}
            pageNumber={1}
            width={200}
            height={300}
            className="pdf-container-custom"
          />
        </Document>
      </React.Suspense>
    </S.Wrapper>
  );
};

export const PdfThumbnail = ({ fileUrl }: PdfDocumentProps) => (
  <ClientComponent>
    <PdfThumbnailComponent fileUrl={fileUrl} />
  </ClientComponent>
);
